export default {"id":"802d0d04","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}